/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../legalentities/model/model';
import './common';
import '../../common/location';
import '../../paymentactivator/activations';
import './status';
import '../../common/countries';
import './model';
import '../../deposits/bank_account_service';
import '../../capital/business/service';
import '../../sfs/services/customer/get_account_transfer_eligibility';
import '../../common/time';
import '../../common/languages';
import './jp/common';
import '../../secure_profile/common';
import '../../identityverifier/model/business_attributes';
import '../../common/address';
import '../../legalentities/verification/verification';
import '../../client/status';
import '../../cash/cashidv/common/Identity';
import '../../onboarding/business/us';
import './us/common';
import './accountCreation/service';
import '../../common/messages';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "service": {
                "nested": {
                  "Individual": {
                    "fields": {
                      "leNodeToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "relationship": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship",
                        "id": 2,
                        "rule": "optional"
                      },
                      "name": {
                        "type": ".squareup.onboard.activation.common.Name",
                        "id": 3,
                        "rule": "optional"
                      },
                      "birthDate": {
                        "type": ".squareup.onboard.activation.common.BirthDate",
                        "id": 4,
                        "rule": "optional"
                      },
                      "gender": {
                        "type": ".squareup.onboard.activation.common.Gender",
                        "id": 5,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 6,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "email": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "personalNumericalIdentifier": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "incorrect": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      },
                      "incorrectReason": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "vendorPrefill": {
                        "type": "bool",
                        "id": 12,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "VerificationDecision": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "INIT": 1,
                      "IN_PROGRESS": 2,
                      "VERIFIED": 3,
                      "DECLINED": 4,
                      "RETRY": 5,
                      "UNDER_REVIEW": 6,
                      "BUSINESS_VERIFICATION_RETRY": 7
                    }
                  },
                  "BusinessStructureStatus": {
                    "fields": {
                      "status": {
                        "type": ".squareup.onboard.activation.service.VerificationDecision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "attempts": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "nodeStatus": {
                        "type": ".squareup.onboard.activation.service.BusinessStructureStatus.NodeVerificationStatus",
                        "id": 3,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "NodeVerificationStatus": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "VERIFIED": 2,
                          "DECLINED": 3,
                          "RETRY": 4,
                          "SSN": 5
                        }
                      }
                    }
                  },
                  "GetBusinessStructureRequest": {
                    "fields": {}
                  },
                  "GetBusinessStructureResponse": {
                    "fields": {
                      "prefillStatus": {
                        "type": ".squareup.onboard.activation.service.GetBusinessStructureResponse.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "individuals": {
                        "type": ".squareup.onboard.activation.service.Individual",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "businessStructureStatus": {
                        "type": ".squareup.onboard.activation.service.BusinessStructureStatus",
                        "id": 3,
                        "rule": "optional"
                      },
                      "paymentActivationState": {
                        "type": ".squareup.paymentactivator.ActivationState",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "SUCCESS": 2,
                          "FAILED": 3,
                          "UNSUPPORTED": 4
                        }
                      }
                    }
                  },
                  "UpdateBusinessStructureRequest": {
                    "fields": {
                      "individuals": {
                        "type": ".squareup.onboard.activation.service.Individual",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "ownershipStructure": {
                        "type": ".squareup.onboard.activation.common.OwnershipStructure",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateBusinessStructureResponse": {
                    "fields": {
                      "individuals": {
                        "type": ".squareup.onboard.activation.service.Individual",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "businessStructureStatus": {
                        "type": ".squareup.onboard.activation.service.BusinessStructureStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "statusResponse": {
                        "type": ".squareup.onboard.activation.status.StatusResponse",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCbdProgramStatusRequest": {
                    "fields": {}
                  },
                  "GetCbdProgramStatusResponse": {
                    "fields": {
                      "inCbdProgram": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetCbdFlagRequest": {
                    "fields": {}
                  },
                  "GetCbdFlagResponse": {
                    "fields": {
                      "isCbdSeller": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SetCbdFlagRequest": {
                    "fields": {
                      "isCbdSeller": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessInformationRequest": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "receiptName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "businessCategory": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "businessSubCategory": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "merchantAnalytic": {
                        "type": ".squareup.onboard.activation.common.MerchantAnalytic",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "business": {
                        "type": ".squareup.onboard.activation.model.Business",
                        "id": 6,
                        "rule": "optional"
                      },
                      "verificationId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  },
                  "MerchantAnalyticRequest": {
                    "fields": {
                      "merchantAnalytic": {
                        "type": ".squareup.onboard.activation.common.MerchantAnalytic",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "PersonalInformationRequest": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "persona": {
                        "type": ".squareup.onboard.activation.model.Persona",
                        "id": 2,
                        "rule": "optional"
                      },
                      "document": {
                        "type": ".squareup.onboard.activation.model.Document",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferPersonalInformationRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 2,
                        "rule": "optional"
                      },
                      "persona": {
                        "type": ".squareup.onboard.activation.model.Persona",
                        "id": 3,
                        "rule": "optional"
                      },
                      "document": {
                        "type": ".squareup.onboard.activation.model.Document",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "BeneficialOwnershipRequest": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "persona": {
                        "type": ".squareup.onboard.activation.model.Persona",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "ownershipStructure": {
                        "type": ".squareup.onboard.activation.common.OwnershipStructure",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferUnderwritingStatusRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UnderwritingStatusRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UnderwritingStatusResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "underwritingStatus": {
                        "type": ".squareup.onboard.activation.common.UnderwritingStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "decision": {
                        "type": ".squareup.onboard.activation.common.Decision",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "BankAccountRequest": {
                    "fields": {
                      "bankAccount": {
                        "type": ".squareup.onboard.activation.model.BankAccount",
                        "id": 1,
                        "rule": "optional"
                      },
                      "idempotenceKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountHolderRelationshipToBusiness": {
                        "type": ".squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "DebitAuthorizationRequest": {
                    "fields": {
                      "bankAccountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "DecryptEmailAddressRequest": {
                    "fields": {
                      "enc": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "DecryptEmailAddressResponse": {
                    "fields": {
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "emailAddress": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetTransferEligibilityDoubleCheckRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetTransferEligibilityResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isEligible": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "violations": {
                        "type": ".squareup.onboard.activation.service.GetTransferEligibilityResponse.Violation",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "hasSquareCard": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "hasTapToPayOnIphoneLinked": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "capitalViolations": {
                        "type": ".squareup.capital.business.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "savingsViolations": {
                        "type": ".squareup.sfs.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason",
                        "id": 6,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Violation": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "NO_EIN_OR_SSN": 1,
                          "TWO_FACTOR_ENABLED": 2,
                          "NEGATIVE_BALANCE": 3,
                          "FROZEN": 4,
                          "DISABLED": 5,
                          "PAYROLL_SUBSCRIPTION": 6,
                          "CAPITAL_REQUIREMENT": 7,
                          "CANNABIS_PROGRAM": 8,
                          "UNSUPPORTED_BUSINESS_STRUCTURE": 9,
                          "SAVINGS_ACCOUNT": 10,
                          "UNVERIFIED_LEGAL_ENTITY": 11
                        }
                      }
                    }
                  },
                  "GetInitiateTransferRequiredAttributesResponse": {
                    "fields": {
                      "oldDesignateFirstName": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "oldDesignateLastName": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "oldDesignateDateOfBirth": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "oldDesignateAddress": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "oldDesignatePhoneNumber": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "attributesSets": {
                        "type": ".squareup.onboard.activation.service.InitiateTransferRequiredAttributes",
                        "id": 8,
                        "rule": "repeated"
                      },
                      "oldDesignateSsnLastFourDigits": {
                        "type": "bool",
                        "id": 6
                      },
                      "oldDesignateSinLastFourDigits": {
                        "type": "bool",
                        "id": 7
                      }
                    },
                    "nested": {
                      "identifier": {
                        "oneof": ["oldDesignateSsnLastFourDigits", "oldDesignateSinLastFourDigits"]
                      }
                    }
                  },
                  "InitiateTransferRequiredAttributes": {
                    "fields": {
                      "setName": {
                        "type": ".squareup.onboard.activation.service.AttributesSetName",
                        "id": 1,
                        "rule": "optional"
                      },
                      "oldDesignateFirstName": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "oldDesignateLastName": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "oldDesignateDateOfBirth": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "oldDesignateAddress": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "oldDesignatePhoneNumber": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "oldDesignateBsbNumber": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "oldDesignateBankAccountLastThreeDigits": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      },
                      "oldDesignateSsnLastFourDigits": {
                        "type": "bool",
                        "id": 7
                      },
                      "oldDesignateSinLastFourDigits": {
                        "type": "bool",
                        "id": 8
                      }
                    },
                    "nested": {
                      "identifier": {
                        "oneof": ["oldDesignateSsnLastFourDigits", "oldDesignateSinLastFourDigits"]
                      }
                    }
                  },
                  "AttributesSetName": {
                    "values": {
                      "ATTRIBUTES_SET_NAME_DO_NOT_USE": 0,
                      "REQUIRED_ATTRIBUTES_US": 1,
                      "REQUIRED_ATTRIBUTES_CA_WITH_SIN": 2,
                      "REQUIRED_ATTRIBUTES_CA_NO_SIN": 3,
                      "REQUIRED_ATTRIBUTES_AU": 4,
                      "REQUIRED_ATTRIBUTES_AU_ALTERNATIVE": 5,
                      "REQUIRED_ATTRIBUTES_GB": 6
                    }
                  },
                  "VerifyOldDesignateRequest": {
                    "fields": {
                      "attributeSetName": {
                        "type": ".squareup.onboard.activation.service.AttributesSetName",
                        "id": 10,
                        "rule": "optional"
                      },
                      "oldDesignateFirstName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "oldDesignateLastName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "oldDesignateDateOfBirth": {
                        "type": ".squareup.onboard.activation.common.BirthDate",
                        "id": 3,
                        "rule": "optional"
                      },
                      "oldDesignateAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 6,
                        "rule": "optional"
                      },
                      "oldDesignatePhoneNumber": {
                        "type": ".squareup.common.location.Phone",
                        "id": 7,
                        "rule": "optional"
                      },
                      "oldDesignateBsbNumber": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "oldDesignateBankAccountLastThreeDigits": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "oldDesignateSsnLastFourDigits": {
                        "type": "string",
                        "id": 4
                      },
                      "oldDesignateSinLastFourDigits": {
                        "type": "string",
                        "id": 5
                      }
                    },
                    "nested": {
                      "identifier": {
                        "oneof": ["oldDesignateSsnLastFourDigits", "oldDesignateSinLastFourDigits"]
                      }
                    }
                  },
                  "VerifyOldDesignateResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "verificationAttemptsRemaining": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "StartTransferRequest": {
                    "fields": {
                      "newDesignateEmailAddress": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "AccountOwnershipTransferStatusResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "createdAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.common.AccountOwnershipTransferStatus",
                        "id": 4,
                        "rule": "optional"
                      },
                      "transferStatus": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "newDesignateRetriesExhausted": {
                        "type": "bool",
                        "id": 6,
                        "rule": "optional"
                      },
                      "newDesignateEmailAddress": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "ineligibleForTransferReason": {
                        "type": ".squareup.onboard.activation.service.AccountOwnershipTransferStatusResponse.IneligibleForTransferReason",
                        "id": 8,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "IneligibleForTransferReason": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "UNSUPPORTED_BUSINESS_STRUCTURE": 1
                        }
                      }
                    }
                  },
                  "GetTaxLocationsRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetTaxLocationsResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "locations": {
                        "type": ".squareup.onboard.activation.service.GetTaxLocationsResponse.TaxLocation",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "TaxLocation": {
                        "fields": {
                          "name": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "isEinOnFile": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "GetBeneficialOwnersRequest": {
                    "fields": {}
                  },
                  "GetBeneficialOwnersResponse": {
                    "fields": {
                      "beneficialOwners": {
                        "type": ".squareup.onboard.activation.model.Persona",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.service.GetBeneficialOwnersResponse.PopulateStatus",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PopulateStatus": {
                        "values": {
                          "IN_PROGRESS": 1,
                          "SUCCESS": 2,
                          "FAILED": 3
                        }
                      }
                    }
                  },
                  "BeginDocIdvRequest": {
                    "fields": {
                      "productIntent": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "testIdentity": {
                        "type": ".squareup.onboard.activation.service.BeginDocIdvRequest.TestIdentity",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TestIdentity": {
                        "fields": {
                          "givenName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "familyName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "documentType": {
                            "type": ".squareup.onboard.activation.service.BeginDocIdvRequest.DocumentType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "documentNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "documentCountry": {
                            "type": ".squareup.common.countries.Country",
                            "id": 5,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "DocumentType": {
                        "values": {
                          "PASSPORT": 1,
                          "DRIVERS_LICENSE": 2,
                          "ID_CARD": 3,
                          "RESIDENCE_PERMIT": 4
                        }
                      }
                    }
                  },
                  "DocIdvSession": {
                    "fields": {
                      "vendorName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sessionIdentifier": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "sessionToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "BeginDocIdvResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "docIdvSessionUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "session": {
                        "type": ".squareup.onboard.activation.service.DocIdvSession",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessCategoriesRequest": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "languageCode": {
                        "type": ".squareup.common.languages.Language",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessCategory": {
                    "fields": {
                      "key": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "subCategories": {
                        "type": ".squareup.onboard.activation.service.BusinessSubCategory",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "subCategoriesTitle": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessSubCategory": {
                    "fields": {
                      "key": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessCategoriesResponse": {
                    "fields": {
                      "businessCategories": {
                        "type": ".squareup.onboard.activation.service.BusinessCategory",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "TriggerUnitPaymentBrandEnrollmentRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentBrand": {
                        "type": ".squareup.onboard.activation.common.PaymentBrand",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "TriggerUnitPaymentBrandEnrollmentResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      },
                      "response": {
                        "type": ".squareup.onboard.activation.service.UnitPaymentBrandEnrollmentStatus",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1,
                          "INVALID_PAYMENT_BRAND": 2,
                          "MISSING_JCB_DATA": 3
                        }
                      }
                    }
                  },
                  "GetUnitPaymentBrandEnrollmentStatusRequest": {
                    "fields": {
                      "unitTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "GetUnitPaymentBrandEnrollmentStatusResponse": {
                    "fields": {
                      "responses": {
                        "type": ".squareup.onboard.activation.service.UnitPaymentBrandEnrollmentStatus",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "RegisterEmoneyIntentRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RegisterEmoneyIntentResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.RegisterEmoneyIntentResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1
                        }
                      }
                    }
                  },
                  "GetUnifiedEmoneyEligibilityRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetUnifiedEmoneyEligibilityResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eligible": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1
                        }
                      }
                    }
                  },
                  "UnitPaymentBrandEnrollmentStatus": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentBrands": {
                        "type": ".squareup.onboard.activation.common.PaymentBrandEnrollmentStatus",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "applyToAllEmoneyBrands": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetJcbBankDataRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetJcbBankDataResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.GetJcbBankDataResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fields": {
                        "type": ".squareup.onboard.activation.common.KeyValuePair",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "jcbFields": {
                        "type": ".squareup.onboard.activation.jp.common.JcbField",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1
                        }
                      }
                    }
                  },
                  "SetJcbBankDataRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fields": {
                        "type": ".squareup.onboard.activation.common.KeyValuePair",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "SetJcbBankDataResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.SetJcbBankDataResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1,
                          "INVALID_FIELDS": 2
                        }
                      }
                    }
                  },
                  "CreateJcbSspRequestRequest": {
                    "fields": {
                      "target": {
                        "type": ".squareup.secure_profile.common.Target",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateJcbSspRequestResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "sspRequestToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.service.CreateJcbSspRequestResponse.SspStatus",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SspStatus": {
                        "values": {
                          "PREPARING": 1,
                          "PENDING_COMPLETION": 2,
                          "COMPLETE": 3
                        }
                      }
                    }
                  },
                  "CreateEmoneySspRequestRequest": {
                    "fields": {
                      "target": {
                        "type": ".squareup.secure_profile.common.Target",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreateEmoneySspRequestResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "sspRequestToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.service.CreateEmoneySspRequestResponse.SspStatus",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "SspStatus": {
                        "values": {
                          "PREPARING": 1,
                          "PENDING_COMPLETION": 2,
                          "COMPLETE": 3
                        }
                      }
                    }
                  },
                  "ContinueJcbOnboardingRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ContinueJcbOnboardingResponse": {
                    "fields": {
                      "error": {
                        "type": ".squareup.onboard.activation.service.ContinueJcbOnboardingResponse.Error",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.service.ContinueJcbOnboardingResponse.JcbOnboardingStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "irfToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "INVALID_UNIT": 1
                        }
                      },
                      "JcbOnboardingStatus": {
                        "values": {
                          "PROCESSING": 1,
                          "APPLIED": 2,
                          "ERRORED": 3
                        }
                      }
                    }
                  },
                  "ShouldSkipBankLinkingStepRequest": {
                    "fields": {
                      "unitToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ShouldSkipBankLinkingStepResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "error": {
                        "type": ".squareup.onboard.activation.service.ShouldSkipBankLinkingStepResponse.Error",
                        "id": 2,
                        "rule": "optional"
                      },
                      "shouldSkipBankLinkingStep": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Error": {
                        "values": {
                          "NO_ERROR": 0,
                          "FAILED_TO_CHECK_BANK_ACCOUNTS": 1
                        }
                      }
                    }
                  },
                  "SetPrimaryIndividualControlRelationshipRequest": {
                    "fields": {
                      "role": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship.Role",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ownership": {
                        "type": ".squareup.legalentities.model.Business.ControlRelationship.Ownership",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SetPrimaryIndividualControlRelationshipResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "BusinessLookupRequest": {
                    "fields": {
                      "businessIdentifiers": {
                        "type": ".squareup.identityverifier.model.BusinessAttributes.BusinessIdentifier",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "address": {
                        "type": ".squareup.common.address.Address",
                        "id": 2,
                        "rule": "optional"
                      },
                      "productIntent": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessLookupResponse": {
                    "fields": {
                      "businessAttributes": {
                        "type": ".squareup.identityverifier.model.BusinessAttributes",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetAsyncIDVInvitationInfoRequest": {
                    "fields": {
                      "invitationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetAsyncIDVInvitationInfoResponse": {
                    "fields": {
                      "firstName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "legalEntitiesNodeToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "role": {
                        "type": ".squareup.onboard.activation.common.BeneficialOwnerRole",
                        "id": 4,
                        "rule": "optional"
                      },
                      "signupPersonLastName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "signupPersonFirstName": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "businessName": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.onboard.activation.service.GetAsyncIDVInvitationInfoResponse.IdvInvitationStatus",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "IdvInvitationStatus": {
                        "values": {
                          "COMPLETE": 1,
                          "INCOMPLETE": 2,
                          "EXPIRED": 3,
                          "NOT_FOUND": 4
                        }
                      }
                    }
                  },
                  "IndividualDocIdvRequest": {
                    "fields": {
                      "invitationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "testIdentity": {
                        "type": ".squareup.onboard.activation.service.IndividualDocIdvRequest.TestIdentity",
                        "id": 2,
                        "rule": "optional"
                      },
                      "productIntent": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "TestIdentity": {
                        "fields": {
                          "givenName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "familyName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "documentType": {
                            "type": ".squareup.onboard.activation.service.IndividualDocIdvRequest.DocumentType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "documentNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "documentCountry": {
                            "type": ".squareup.common.countries.Country",
                            "id": 5,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "DocumentType": {
                        "values": {
                          "PASSPORT": 1,
                          "DRIVERS_LICENSE": 2,
                          "ID_CARD": 3,
                          "RESIDENCE_PERMIT": 4
                        }
                      }
                    }
                  },
                  "IndividualDocIdvResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "docIdvSessionUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "session": {
                        "type": ".squareup.onboard.activation.service.DocIdvSession",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateIndividualRequest": {
                    "fields": {
                      "invitationToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.common.address.Address",
                        "id": 2,
                        "rule": "optional"
                      },
                      "dateOfBirth": {
                        "type": ".squareup.onboard.activation.common.BirthDate",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetIDVStatusForAllIndividualsInLegalEntityRequest": {
                    "fields": {
                      "companyIdentifier": {
                        "type": ".squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityRequest.CompanyIdentifier",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CompanyIdentifier": {
                        "fields": {
                          "activationFlowId": {
                            "type": "int32",
                            "id": 1
                          },
                          "merchantToken": {
                            "type": "string",
                            "id": 2
                          },
                          "legalEntityStructureToken": {
                            "type": "string",
                            "id": 3
                          }
                        },
                        "nested": {
                          "value": {
                            "oneof": ["activationFlowId", "merchantToken", "legalEntityStructureToken"]
                          }
                        }
                      }
                    }
                  },
                  "IndividualIdvStatusType": {
                    "values": {
                      "PENDING": 1,
                      "EXPIRED": 2,
                      "COMPLETE": 3,
                      "DECLINED_RETRIES_ALLOWED": 4,
                      "DECLINED_NO_RETRIES_ALLOWED": 5
                    }
                  },
                  "GetIDVStatusForAllIndividualsInLegalEntityResponse": {
                    "fields": {
                      "legalEntityStructureToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "individualInfo": {
                        "type": ".squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityResponse.IndividualInfo",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "IndividualInfo": {
                        "fields": {
                          "givenName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "familyName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "email": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "legalEntityNodeToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "idvStatus": {
                            "type": ".squareup.onboard.activation.service.IndividualIdvStatusType",
                            "id": 5,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 6,
                            "rule": "optional"
                          },
                          "emailSentAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 7,
                            "rule": "optional"
                          },
                          "role": {
                            "type": ".squareup.onboard.activation.common.BeneficialOwnerRole",
                            "id": 8,
                            "rule": "optional"
                          },
                          "primaryIndividual": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "docIdvState": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession.State",
                            "id": 10,
                            "rule": "optional"
                          },
                          "idvInvitationUrl": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "SendIdvReminderEmailRequest": {
                    "fields": {
                      "legalEntitiesStructureToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legalEntitiesNodeToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SendIdvReminderEmailResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "SendIdvRetryEmailRequest": {
                    "fields": {
                      "legalEntitiesStructureToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legalEntitiesNodeToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "SendIdvRetryEmailResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateBeneficialOwnerDirectorEmailRequest": {
                    "fields": {
                      "legalEntitiesStructureToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "legalEntitiesNodeToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "email": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "UpdateBeneficialOwnerDirectorEmailResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "statusResponse": {
                        "type": ".squareup.onboard.activation.status.StatusResponse",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "InitiateSellerNameChangeRequest": {
                    "fields": {}
                  },
                  "GetBusinessVerificationStatusRequest": {
                    "fields": {
                      "companyIdentifier": {
                        "type": ".squareup.onboard.activation.common.CompanyIdentifier",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BusinessVerificationStatus": {
                    "fields": {
                      "status": {
                        "type": ".squareup.onboard.activation.service.BusinessVerificationStatus.VerificationStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "attempts": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "personalIdentificationNumberOptionalForIdv": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "VerificationStatus": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "VERIFIED": 2,
                          "DECLINED": 3
                        }
                      }
                    }
                  },
                  "GetBusinessVerificationStatusResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.onboard.activation.service.GetBusinessVerificationStatusResponse.VerificationStatus",
                        "id": 1,
                        "rule": "optional"
                      },
                      "attempts": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "personalIdentificationNumberOptionalForIdv": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      },
                      "verificationStatus": {
                        "type": ".squareup.onboard.activation.service.BusinessVerificationStatus",
                        "id": 4,
                        "rule": "optional"
                      },
                      "clientStatus": {
                        "type": ".squareup.client.Status",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "VerificationStatus": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "VERIFIED": 2,
                          "DECLINED": 3
                        }
                      }
                    }
                  },
                  "TriggerVerifyBusinessRequest": {
                    "fields": {
                      "companyIdentifier": {
                        "type": ".squareup.onboard.activation.common.CompanyIdentifier",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "HandleC4BSignupRequest": {
                    "fields": {
                      "encryptedCashCustomerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "eligibleForPrefill": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cashFlowToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "HandleC4BSignupResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.onboard.activation.status.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "sms": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "name": {
                        "type": ".squareup.cash.cashidv.common.Name",
                        "id": 4,
                        "rule": "optional"
                      },
                      "birthdate": {
                        "type": ".squareup.cash.cashidv.common.BirthDate",
                        "id": 5,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 6,
                        "rule": "optional"
                      },
                      "businessType": {
                        "type": ".squareup.onboarding.business.UsBusiness.Type",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  },
                  "BeginTransferDocIdvRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "productIntent": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "testIdentity": {
                        "type": ".squareup.onboard.activation.service.BeginDocIdvRequest.TestIdentity",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferDocIdvRemainingRetryCountRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferDocIdvRemainingRetryCountResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "remainingRetryCount": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferMerchantTokenRequest": {
                    "fields": {
                      "uuid": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "TransferMerchantTokenResponse": {
                    "fields": {
                      "success": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetPrimaryIndividualDocIdvStatusRequest": {
                    "fields": {}
                  },
                  "GetPrimaryIndividualDocIdvStatusResponse": {
                    "fields": {
                      "state": {
                        "type": ".squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusResponse.PrimaryIndividualDocIdvState",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PrimaryIndividualDocIdvState": {
                        "values": {
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DO_NOT_USE": 0,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_NO_PRIMARY_INDIVIDUAL_FOR_STRUCTURE_TOKEN": 1,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_NOT_STARTED": 2,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_AWAITING_SUBMISSION": 3,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_COMPLETED_VERIFIED": 4,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_COMPLETED_NOT_VERIFIED": 5,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_SUBMITTED": 6,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_RESUBMISSION_REQUESTED": 7,
                          "PRIMARY_INDIVIDUAL_DOC_IDV_STATE_DOC_IDV_COMPLETED_ATTRIBUTES_MISMATCH": 8
                        }
                      }
                    }
                  },
                  "StartQuickVerifyRequest": {
                    "fields": {
                      "phoneNumber": {
                        "type": ".squareup.common.location.Phone",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ssnLast4": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "StartQuickVerifyResponse": {
                    "fields": {
                      "status": {
                        "type": ".squareup.onboard.activation.status.StatusResponse",
                        "id": 1,
                        "rule": "optional"
                      },
                      "verificationId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetQuickVerifyStatusRequest": {
                    "fields": {
                      "verificationId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "QuickVerifyPrefillData": {
                    "fields": {
                      "name": {
                        "type": ".squareup.onboard.activation.common.Name",
                        "id": 1,
                        "rule": "optional"
                      },
                      "birthDate": {
                        "type": ".squareup.onboard.activation.common.BirthDate",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ssnFideliusToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": ".squareup.common.location.Phone",
                        "id": 4,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.onboard.activation.us.common.Address",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "GetQuickVerifyStatusResponse": {
                    "fields": {
                      "inProgress": {
                        "type": ".squareup.onboard.activation.service.GetQuickVerifyStatusResponse.InProgress",
                        "id": 1
                      },
                      "complete": {
                        "type": ".squareup.onboard.activation.service.GetQuickVerifyStatusResponse.Complete",
                        "id": 2
                      },
                      "failure": {
                        "type": ".squareup.onboard.activation.service.GetQuickVerifyStatusResponse.Failure",
                        "id": 3
                      }
                    },
                    "nested": {
                      "InProgress": {
                        "fields": {}
                      },
                      "Complete": {
                        "fields": {
                          "prefillData": {
                            "type": ".squareup.onboard.activation.service.QuickVerifyPrefillData",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Failure": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.onboard.activation.status.Error",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "status": {
                        "oneof": ["inProgress", "complete", "failure"]
                      }
                    }
                  },
                  "AcceptQuickVerifyPrefillRequest": {
                    "fields": {
                      "verificationId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Service": {
                    "methods": {
                      "CreateAccount": {
                        "requestType": ".squareup.onboard.activation.accountCreation.service.AccountCreationRequest",
                        "responseType": ".squareup.onboard.activation.accountCreation.service.AccountCreationResponse"
                      },
                      "GetCbdProgramStatus": {
                        "requestType": ".squareup.onboard.activation.service.GetCbdProgramStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetCbdProgramStatusResponse"
                      },
                      "GetCbdFlag": {
                        "requestType": ".squareup.onboard.activation.service.GetCbdFlagRequest",
                        "responseType": ".squareup.onboard.activation.service.GetCbdFlagResponse"
                      },
                      "SetCbdFlag": {
                        "requestType": ".squareup.onboard.activation.service.SetCbdFlagRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "FailCbdQuestionnaire": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "UpdateBusinessInformation": {
                        "requestType": ".squareup.onboard.activation.service.BusinessInformationRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "UpdateMerchantAnalytic": {
                        "requestType": ".squareup.onboard.activation.service.MerchantAnalyticRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "UpdatePersonalInformation": {
                        "requestType": ".squareup.onboard.activation.service.PersonalInformationRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "UpdateTransferPersonalInformation": {
                        "requestType": ".squareup.onboard.activation.service.TransferPersonalInformationRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "UpdateBeneficialOwnership": {
                        "requestType": ".squareup.onboard.activation.service.BeneficialOwnershipRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "GetUnderwritingStatus": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.UnderwritingStatusResponse"
                      },
                      "GetUnderwritingStatusForOps": {
                        "requestType": ".squareup.onboard.activation.service.UnderwritingStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.UnderwritingStatusResponse"
                      },
                      "GetTransferUnderwritingStatus": {
                        "requestType": ".squareup.onboard.activation.service.TransferUnderwritingStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.UnderwritingStatusResponse"
                      },
                      "GetBeneficialOwnershipUnderwritingStatus": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.UnderwritingStatusResponse"
                      },
                      "UpdateBankAccount": {
                        "requestType": ".squareup.onboard.activation.service.BankAccountRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "ConfirmDebitAuthorization": {
                        "requestType": ".squareup.onboard.activation.service.DebitAuthorizationRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "DecryptEmailAddress": {
                        "requestType": ".squareup.onboard.activation.service.DecryptEmailAddressRequest",
                        "responseType": ".squareup.onboard.activation.service.DecryptEmailAddressResponse"
                      },
                      "GetTransferEligibility": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.GetTransferEligibilityResponse"
                      },
                      "GetTransferEligibilityDoubleCheck": {
                        "requestType": ".squareup.onboard.activation.service.GetTransferEligibilityDoubleCheckRequest",
                        "responseType": ".squareup.onboard.activation.service.GetTransferEligibilityResponse"
                      },
                      "GetInitiateTransferRequiredAttributes": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.GetInitiateTransferRequiredAttributesResponse"
                      },
                      "VerifyOldDesignate": {
                        "requestType": ".squareup.onboard.activation.service.VerifyOldDesignateRequest",
                        "responseType": ".squareup.onboard.activation.service.VerifyOldDesignateResponse"
                      },
                      "StartTransfer": {
                        "requestType": ".squareup.onboard.activation.service.StartTransferRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "GetAccountOwnershipTransferStatus": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.service.AccountOwnershipTransferStatusResponse"
                      },
                      "GetBeneficialOwners": {
                        "requestType": ".squareup.onboard.activation.service.GetBeneficialOwnersRequest",
                        "responseType": ".squareup.onboard.activation.service.GetBeneficialOwnersResponse"
                      },
                      "GetBusinessCategories": {
                        "requestType": ".squareup.onboard.activation.service.BusinessCategoriesRequest",
                        "responseType": ".squareup.onboard.activation.service.BusinessCategoriesResponse"
                      },
                      "GetUnitPaymentBrandStatus": {
                        "requestType": ".squareup.onboard.activation.service.GetUnitPaymentBrandEnrollmentStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetUnitPaymentBrandEnrollmentStatusResponse"
                      },
                      "GetTaxLocations": {
                        "requestType": ".squareup.onboard.activation.service.GetTaxLocationsRequest",
                        "responseType": ".squareup.onboard.activation.service.GetTaxLocationsResponse"
                      },
                      "TriggerUnitPaymentBrandEnrollment": {
                        "requestType": ".squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentRequest",
                        "responseType": ".squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentResponse"
                      },
                      "RegisterEmoneyIntent": {
                        "requestType": ".squareup.onboard.activation.service.RegisterEmoneyIntentRequest",
                        "responseType": ".squareup.onboard.activation.service.RegisterEmoneyIntentResponse"
                      },
                      "GetUnifiedEmoneyEligibility": {
                        "requestType": ".squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityRequest",
                        "responseType": ".squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityResponse"
                      },
                      "GetJcbBankData": {
                        "requestType": ".squareup.onboard.activation.service.GetJcbBankDataRequest",
                        "responseType": ".squareup.onboard.activation.service.GetJcbBankDataResponse"
                      },
                      "SetJcbBankData": {
                        "requestType": ".squareup.onboard.activation.service.SetJcbBankDataRequest",
                        "responseType": ".squareup.onboard.activation.service.SetJcbBankDataResponse"
                      },
                      "CreateJcbSspRequest": {
                        "requestType": ".squareup.onboard.activation.service.CreateJcbSspRequestRequest",
                        "responseType": ".squareup.onboard.activation.service.CreateJcbSspRequestResponse"
                      },
                      "CreateEmoneySspRequest": {
                        "requestType": ".squareup.onboard.activation.service.CreateEmoneySspRequestRequest",
                        "responseType": ".squareup.onboard.activation.service.CreateEmoneySspRequestResponse"
                      },
                      "ContinueJcbOnboarding": {
                        "requestType": ".squareup.onboard.activation.service.ContinueJcbOnboardingRequest",
                        "responseType": ".squareup.onboard.activation.service.ContinueJcbOnboardingResponse"
                      },
                      "ShouldSkipBankLinkingStep": {
                        "requestType": ".squareup.onboard.activation.service.ShouldSkipBankLinkingStepRequest",
                        "responseType": ".squareup.onboard.activation.service.ShouldSkipBankLinkingStepResponse"
                      },
                      "SetPrimaryIndividualControlRelationship": {
                        "requestType": ".squareup.onboard.activation.service.SetPrimaryIndividualControlRelationshipRequest",
                        "responseType": ".squareup.onboard.activation.service.SetPrimaryIndividualControlRelationshipResponse"
                      },
                      "TriggerBusinessLookup": {
                        "requestType": ".squareup.onboard.activation.service.BusinessLookupRequest",
                        "responseType": ".squareup.onboard.activation.service.BusinessLookupResponse"
                      },
                      "GetAsyncIDVInvitationInfo": {
                        "requestType": ".squareup.onboard.activation.service.GetAsyncIDVInvitationInfoRequest",
                        "responseType": ".squareup.onboard.activation.service.GetAsyncIDVInvitationInfoResponse"
                      },
                      "IndividualDocIdv": {
                        "requestType": ".squareup.onboard.activation.service.IndividualDocIdvRequest",
                        "responseType": ".squareup.onboard.activation.service.IndividualDocIdvResponse"
                      },
                      "UpdateIndividual": {
                        "requestType": ".squareup.onboard.activation.service.UpdateIndividualRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "GetIDVStatusForAllIndividualsInLegalEntity": {
                        "requestType": ".squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityRequest",
                        "responseType": ".squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityResponse"
                      },
                      "SendIdvReminderEmail": {
                        "requestType": ".squareup.onboard.activation.service.SendIdvReminderEmailRequest",
                        "responseType": ".squareup.onboard.activation.service.SendIdvReminderEmailResponse"
                      },
                      "SendIdvRetryEmail": {
                        "requestType": ".squareup.onboard.activation.service.SendIdvRetryEmailRequest",
                        "responseType": ".squareup.onboard.activation.service.SendIdvRetryEmailResponse"
                      },
                      "UpdateBeneficialOwnerDirectorEmail": {
                        "requestType": ".squareup.onboard.activation.service.UpdateBeneficialOwnerDirectorEmailRequest",
                        "responseType": ".squareup.onboard.activation.service.UpdateBeneficialOwnerDirectorEmailResponse"
                      },
                      "InitiateSellerNameChange": {
                        "requestType": ".squareup.onboard.activation.service.InitiateSellerNameChangeRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "SendNotifyOldDesignate": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "SendNotifyNewDesignate": {
                        "requestType": ".squareup.common.messages.Empty",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "GetBusinessVerificationStatus": {
                        "requestType": ".squareup.onboard.activation.service.GetBusinessVerificationStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetBusinessVerificationStatusResponse"
                      },
                      "GetBusinessVerificationStatusForOps": {
                        "requestType": ".squareup.onboard.activation.service.GetBusinessVerificationStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetBusinessVerificationStatusResponse"
                      },
                      "TriggerVerifyBusiness": {
                        "requestType": ".squareup.onboard.activation.service.TriggerVerifyBusinessRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      },
                      "GetBusinessStructure": {
                        "requestType": ".squareup.onboard.activation.service.GetBusinessStructureRequest",
                        "responseType": ".squareup.onboard.activation.service.GetBusinessStructureResponse"
                      },
                      "UpdateBusinessStructure": {
                        "requestType": ".squareup.onboard.activation.service.UpdateBusinessStructureRequest",
                        "responseType": ".squareup.onboard.activation.service.UpdateBusinessStructureResponse"
                      },
                      "HandleC4BSignup": {
                        "requestType": ".squareup.onboard.activation.service.HandleC4BSignupRequest",
                        "responseType": ".squareup.onboard.activation.service.HandleC4BSignupResponse"
                      },
                      "BeginTransferDocIdv": {
                        "requestType": ".squareup.onboard.activation.service.BeginTransferDocIdvRequest",
                        "responseType": ".squareup.onboard.activation.service.BeginDocIdvResponse"
                      },
                      "GetTransferDocIdvRemainingRetryCount": {
                        "requestType": ".squareup.onboard.activation.service.TransferDocIdvRemainingRetryCountRequest",
                        "responseType": ".squareup.onboard.activation.service.TransferDocIdvRemainingRetryCountResponse"
                      },
                      "GetTransferMerchantToken": {
                        "requestType": ".squareup.onboard.activation.service.TransferMerchantTokenRequest",
                        "responseType": ".squareup.onboard.activation.service.TransferMerchantTokenResponse"
                      },
                      "GetPrimaryIndividualDocIdvStatus": {
                        "requestType": ".squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusResponse"
                      },
                      "StartQuickVerify": {
                        "requestType": ".squareup.onboard.activation.service.StartQuickVerifyRequest",
                        "responseType": ".squareup.onboard.activation.service.StartQuickVerifyResponse"
                      },
                      "GetQuickVerifyStatus": {
                        "requestType": ".squareup.onboard.activation.service.GetQuickVerifyStatusRequest",
                        "responseType": ".squareup.onboard.activation.service.GetQuickVerifyStatusResponse"
                      },
                      "AcceptQuickVerifyPrefill": {
                        "requestType": ".squareup.onboard.activation.service.AcceptQuickVerifyPrefillRequest",
                        "responseType": ".squareup.onboard.activation.status.StatusResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.Individual && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.VerificationDecision && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessStructureStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessStructureStatus?.nested?.NodeVerificationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessStructureRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessStructureResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessStructureResponse?.nested?.Status && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UpdateBusinessStructureRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UpdateBusinessStructureResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetCbdProgramStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetCbdProgramStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetCbdFlagRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetCbdFlagResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetCbdFlagRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessInformationRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.MerchantAnalyticRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.PersonalInformationRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferPersonalInformationRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeneficialOwnershipRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferUnderwritingStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UnderwritingStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UnderwritingStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BankAccountRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.DebitAuthorizationRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.DecryptEmailAddressRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.DecryptEmailAddressResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTransferEligibilityDoubleCheckRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTransferEligibilityResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTransferEligibilityResponse?.nested?.Violation && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetInitiateTransferRequiredAttributesResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.InitiateTransferRequiredAttributes && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.AttributesSetName && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.VerifyOldDesignateRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.VerifyOldDesignateResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.StartTransferRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.AccountOwnershipTransferStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.AccountOwnershipTransferStatusResponse?.nested?.IneligibleForTransferReason && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTaxLocationsRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTaxLocationsResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetTaxLocationsResponse?.nested?.TaxLocation && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBeneficialOwnersRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBeneficialOwnersResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBeneficialOwnersResponse?.nested?.PopulateStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeginDocIdvRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeginDocIdvRequest?.nested?.TestIdentity && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeginDocIdvRequest?.nested?.DocumentType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.DocIdvSession && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeginDocIdvResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessCategoriesRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessCategory && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessSubCategory && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessCategoriesResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TriggerUnitPaymentBrandEnrollmentRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TriggerUnitPaymentBrandEnrollmentResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TriggerUnitPaymentBrandEnrollmentResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetUnitPaymentBrandEnrollmentStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetUnitPaymentBrandEnrollmentStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.RegisterEmoneyIntentRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.RegisterEmoneyIntentResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.RegisterEmoneyIntentResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetUnifiedEmoneyEligibilityRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetUnifiedEmoneyEligibilityResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetUnifiedEmoneyEligibilityResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UnitPaymentBrandEnrollmentStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetJcbBankDataRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetJcbBankDataResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetJcbBankDataResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetJcbBankDataRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetJcbBankDataResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetJcbBankDataResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateJcbSspRequestRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateJcbSspRequestResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateJcbSspRequestResponse?.nested?.SspStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateEmoneySspRequestRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateEmoneySspRequestResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.CreateEmoneySspRequestResponse?.nested?.SspStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ContinueJcbOnboardingRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ContinueJcbOnboardingResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ContinueJcbOnboardingResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ContinueJcbOnboardingResponse?.nested?.JcbOnboardingStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ShouldSkipBankLinkingStepRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ShouldSkipBankLinkingStepResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.ShouldSkipBankLinkingStepResponse?.nested?.Error && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetPrimaryIndividualControlRelationshipRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SetPrimaryIndividualControlRelationshipResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessLookupRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessLookupResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetAsyncIDVInvitationInfoRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetAsyncIDVInvitationInfoResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetAsyncIDVInvitationInfoResponse?.nested?.IdvInvitationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.IndividualDocIdvRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.IndividualDocIdvRequest?.nested?.TestIdentity && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.IndividualDocIdvRequest?.nested?.DocumentType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.IndividualDocIdvResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UpdateIndividualRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetIDVStatusForAllIndividualsInLegalEntityRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetIDVStatusForAllIndividualsInLegalEntityRequest?.nested?.CompanyIdentifier && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.IndividualIdvStatusType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetIDVStatusForAllIndividualsInLegalEntityResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetIDVStatusForAllIndividualsInLegalEntityResponse?.nested?.IndividualInfo && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SendIdvReminderEmailRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SendIdvReminderEmailResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SendIdvRetryEmailRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.SendIdvRetryEmailResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UpdateBeneficialOwnerDirectorEmailRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.UpdateBeneficialOwnerDirectorEmailResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.InitiateSellerNameChangeRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessVerificationStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessVerificationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BusinessVerificationStatus?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessVerificationStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetBusinessVerificationStatusResponse?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TriggerVerifyBusinessRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.HandleC4BSignupRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.HandleC4BSignupResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.BeginTransferDocIdvRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferDocIdvRemainingRetryCountRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferDocIdvRemainingRetryCountResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferMerchantTokenRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.TransferMerchantTokenResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetPrimaryIndividualDocIdvStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetPrimaryIndividualDocIdvStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetPrimaryIndividualDocIdvStatusResponse?.nested?.PrimaryIndividualDocIdvState && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.StartQuickVerifyRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.StartQuickVerifyResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetQuickVerifyStatusRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.QuickVerifyPrefillData && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetQuickVerifyStatusResponse && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetQuickVerifyStatusResponse?.nested?.InProgress && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetQuickVerifyStatusResponse?.nested?.Complete && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.GetQuickVerifyStatusResponse?.nested?.Failure && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.AcceptQuickVerifyPrefillRequest && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.service?.nested?.Service) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Individual @ squareup/onboard/activation/service.proto at 114:1
 */
export const Individual = $root.lookupType('squareup.onboard.activation.service.Individual');
fixType(Individual);
Builder.createAndAttachToType(Individual);
/**
 * SOURCE VerificationDecision @ squareup/onboard/activation/service.proto at 143:1
 */
export const VerificationDecision = $root.lookupEnum('squareup.onboard.activation.service.VerificationDecision').values;
/**
 * SOURCE BusinessStructureStatus @ squareup/onboard/activation/service.proto at 154:1
 */
export const BusinessStructureStatus = $root.lookupType('squareup.onboard.activation.service.BusinessStructureStatus');
fixType(BusinessStructureStatus);
Builder.createAndAttachToType(BusinessStructureStatus);
/**
 * SOURCE NodeVerificationStatus @ squareup/onboard/activation/service.proto at 155:3
 */
BusinessStructureStatus.NodeVerificationStatus = $root.lookupEnum('squareup.onboard.activation.service.BusinessStructureStatus.NodeVerificationStatus').values;
/**
 * SOURCE GetBusinessStructureRequest @ squareup/onboard/activation/service.proto at 169:1
 */
export const GetBusinessStructureRequest = $root.lookupType('squareup.onboard.activation.service.GetBusinessStructureRequest');
fixType(GetBusinessStructureRequest);
Builder.createAndAttachToType(GetBusinessStructureRequest);
/**
 * SOURCE GetBusinessStructureResponse @ squareup/onboard/activation/service.proto at 172:1
 */
export const GetBusinessStructureResponse = $root.lookupType('squareup.onboard.activation.service.GetBusinessStructureResponse');
fixType(GetBusinessStructureResponse);
Builder.createAndAttachToType(GetBusinessStructureResponse);
/**
 * SOURCE Status @ squareup/onboard/activation/service.proto at 173:3
 */
GetBusinessStructureResponse.Status = $root.lookupEnum('squareup.onboard.activation.service.GetBusinessStructureResponse.Status').values;
/**
 * SOURCE UpdateBusinessStructureRequest @ squareup/onboard/activation/service.proto at 187:1
 */
export const UpdateBusinessStructureRequest = $root.lookupType('squareup.onboard.activation.service.UpdateBusinessStructureRequest');
fixType(UpdateBusinessStructureRequest);
Builder.createAndAttachToType(UpdateBusinessStructureRequest);
/**
 * SOURCE UpdateBusinessStructureResponse @ squareup/onboard/activation/service.proto at 192:1
 */
export const UpdateBusinessStructureResponse = $root.lookupType('squareup.onboard.activation.service.UpdateBusinessStructureResponse');
fixType(UpdateBusinessStructureResponse);
Builder.createAndAttachToType(UpdateBusinessStructureResponse);
/**
 * SOURCE GetCbdProgramStatusRequest @ squareup/onboard/activation/service.proto at 198:1
 */
export const GetCbdProgramStatusRequest = $root.lookupType('squareup.onboard.activation.service.GetCbdProgramStatusRequest');
fixType(GetCbdProgramStatusRequest);
Builder.createAndAttachToType(GetCbdProgramStatusRequest);
/**
 * SOURCE GetCbdProgramStatusResponse @ squareup/onboard/activation/service.proto at 201:1
 */
export const GetCbdProgramStatusResponse = $root.lookupType('squareup.onboard.activation.service.GetCbdProgramStatusResponse');
fixType(GetCbdProgramStatusResponse, {
  inCbdProgram: {
    required: true
  }
});
Builder.createAndAttachToType(GetCbdProgramStatusResponse);
/**
 * SOURCE GetCbdFlagRequest @ squareup/onboard/activation/service.proto at 205:1
 */
export const GetCbdFlagRequest = $root.lookupType('squareup.onboard.activation.service.GetCbdFlagRequest');
fixType(GetCbdFlagRequest);
Builder.createAndAttachToType(GetCbdFlagRequest);
/**
 * SOURCE GetCbdFlagResponse @ squareup/onboard/activation/service.proto at 208:1
 */
export const GetCbdFlagResponse = $root.lookupType('squareup.onboard.activation.service.GetCbdFlagResponse');
fixType(GetCbdFlagResponse, {
  isCbdSeller: {
    required: true
  }
});
Builder.createAndAttachToType(GetCbdFlagResponse);
/**
 * SOURCE SetCbdFlagRequest @ squareup/onboard/activation/service.proto at 212:1
 */
export const SetCbdFlagRequest = $root.lookupType('squareup.onboard.activation.service.SetCbdFlagRequest');
fixType(SetCbdFlagRequest, {
  isCbdSeller: {
    required: true
  }
});
Builder.createAndAttachToType(SetCbdFlagRequest);
/**
 * SOURCE BusinessInformationRequest @ squareup/onboard/activation/service.proto at 216:1
 */
export const BusinessInformationRequest = $root.lookupType('squareup.onboard.activation.service.BusinessInformationRequest');
fixType(BusinessInformationRequest);
Builder.createAndAttachToType(BusinessInformationRequest);
/**
 * SOURCE MerchantAnalyticRequest @ squareup/onboard/activation/service.proto at 235:1
 */
export const MerchantAnalyticRequest = $root.lookupType('squareup.onboard.activation.service.MerchantAnalyticRequest');
fixType(MerchantAnalyticRequest);
Builder.createAndAttachToType(MerchantAnalyticRequest);
/**
 * SOURCE PersonalInformationRequest @ squareup/onboard/activation/service.proto at 274:1
 */
export const PersonalInformationRequest = $root.lookupType('squareup.onboard.activation.service.PersonalInformationRequest');
fixType(PersonalInformationRequest);
Builder.createAndAttachToType(PersonalInformationRequest);
/**
 * SOURCE TransferPersonalInformationRequest @ squareup/onboard/activation/service.proto at 282:1
 */
export const TransferPersonalInformationRequest = $root.lookupType('squareup.onboard.activation.service.TransferPersonalInformationRequest');
fixType(TransferPersonalInformationRequest);
Builder.createAndAttachToType(TransferPersonalInformationRequest);
/**
 * SOURCE BeneficialOwnershipRequest @ squareup/onboard/activation/service.proto at 296:1
 */
export const BeneficialOwnershipRequest = $root.lookupType('squareup.onboard.activation.service.BeneficialOwnershipRequest');
fixType(BeneficialOwnershipRequest);
Builder.createAndAttachToType(BeneficialOwnershipRequest);
/**
 * SOURCE TransferUnderwritingStatusRequest @ squareup/onboard/activation/service.proto at 311:1
 */
export const TransferUnderwritingStatusRequest = $root.lookupType('squareup.onboard.activation.service.TransferUnderwritingStatusRequest');
fixType(TransferUnderwritingStatusRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferUnderwritingStatusRequest);
/**
 * SOURCE UnderwritingStatusRequest @ squareup/onboard/activation/service.proto at 319:1
 */
export const UnderwritingStatusRequest = $root.lookupType('squareup.onboard.activation.service.UnderwritingStatusRequest');
fixType(UnderwritingStatusRequest);
Builder.createAndAttachToType(UnderwritingStatusRequest);
/**
 * SOURCE UnderwritingStatusResponse @ squareup/onboard/activation/service.proto at 323:1
 */
export const UnderwritingStatusResponse = $root.lookupType('squareup.onboard.activation.service.UnderwritingStatusResponse');
fixType(UnderwritingStatusResponse);
Builder.createAndAttachToType(UnderwritingStatusResponse);
/**
 * SOURCE BankAccountRequest @ squareup/onboard/activation/service.proto at 332:1
 */
export const BankAccountRequest = $root.lookupType('squareup.onboard.activation.service.BankAccountRequest');
fixType(BankAccountRequest);
Builder.createAndAttachToType(BankAccountRequest);
/**
 * SOURCE DebitAuthorizationRequest @ squareup/onboard/activation/service.proto at 351:1
 */
export const DebitAuthorizationRequest = $root.lookupType('squareup.onboard.activation.service.DebitAuthorizationRequest');
fixType(DebitAuthorizationRequest);
Builder.createAndAttachToType(DebitAuthorizationRequest);
/**
 * SOURCE DecryptEmailAddressRequest @ squareup/onboard/activation/service.proto at 355:1
 */
export const DecryptEmailAddressRequest = $root.lookupType('squareup.onboard.activation.service.DecryptEmailAddressRequest');
fixType(DecryptEmailAddressRequest);
Builder.createAndAttachToType(DecryptEmailAddressRequest);
/**
 * SOURCE DecryptEmailAddressResponse @ squareup/onboard/activation/service.proto at 359:1
 */
export const DecryptEmailAddressResponse = $root.lookupType('squareup.onboard.activation.service.DecryptEmailAddressResponse');
fixType(DecryptEmailAddressResponse);
Builder.createAndAttachToType(DecryptEmailAddressResponse);
/**
 * SOURCE GetTransferEligibilityDoubleCheckRequest @ squareup/onboard/activation/service.proto at 365:1
 */
export const GetTransferEligibilityDoubleCheckRequest = $root.lookupType('squareup.onboard.activation.service.GetTransferEligibilityDoubleCheckRequest');
fixType(GetTransferEligibilityDoubleCheckRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetTransferEligibilityDoubleCheckRequest);
/**
 * SOURCE GetTransferEligibilityResponse @ squareup/onboard/activation/service.proto at 373:1
 */
export const GetTransferEligibilityResponse = $root.lookupType('squareup.onboard.activation.service.GetTransferEligibilityResponse');
fixType(GetTransferEligibilityResponse);
Builder.createAndAttachToType(GetTransferEligibilityResponse);
/**
 * SOURCE Violation @ squareup/onboard/activation/service.proto at 374:3
 */
GetTransferEligibilityResponse.Violation = $root.lookupEnum('squareup.onboard.activation.service.GetTransferEligibilityResponse.Violation').values;
/**
 * SOURCE GetInitiateTransferRequiredAttributesResponse @ squareup/onboard/activation/service.proto at 405:1
 */
export const GetInitiateTransferRequiredAttributesResponse = $root.lookupType('squareup.onboard.activation.service.GetInitiateTransferRequiredAttributesResponse');
fixType(GetInitiateTransferRequiredAttributesResponse);
Builder.createAndAttachToType(GetInitiateTransferRequiredAttributesResponse);
/**
 * Defines a set of attributes that can be used to identify the account owner.
 *
 * SOURCE InitiateTransferRequiredAttributes @ squareup/onboard/activation/service.proto at 421:1
 */
export const InitiateTransferRequiredAttributes = $root.lookupType('squareup.onboard.activation.service.InitiateTransferRequiredAttributes');
fixType(InitiateTransferRequiredAttributes);
Builder.createAndAttachToType(InitiateTransferRequiredAttributes);
/**
 * An identifier for a set of attributes used to verify the account owner.
 *
 * Note: The enum name should be consistent with the Trasfer::OldDesignateVerifier
 *       required attributes constants name so it can be fetched from InitiateTransferRequest by symbol
 *
 * SOURCE AttributesSetName @ squareup/onboard/activation/service.proto at 446:1
 */
export const AttributesSetName = $root.lookupEnum('squareup.onboard.activation.service.AttributesSetName').values;
/**
 * SOURCE VerifyOldDesignateRequest @ squareup/onboard/activation/service.proto at 456:1
 */
export const VerifyOldDesignateRequest = $root.lookupType('squareup.onboard.activation.service.VerifyOldDesignateRequest');
fixType(VerifyOldDesignateRequest);
Builder.createAndAttachToType(VerifyOldDesignateRequest);
/**
 * SOURCE VerifyOldDesignateResponse @ squareup/onboard/activation/service.proto at 474:1
 */
export const VerifyOldDesignateResponse = $root.lookupType('squareup.onboard.activation.service.VerifyOldDesignateResponse');
fixType(VerifyOldDesignateResponse);
Builder.createAndAttachToType(VerifyOldDesignateResponse);
/**
 * SOURCE StartTransferRequest @ squareup/onboard/activation/service.proto at 480:1
 */
export const StartTransferRequest = $root.lookupType('squareup.onboard.activation.service.StartTransferRequest');
fixType(StartTransferRequest);
Builder.createAndAttachToType(StartTransferRequest);
/**
 * SOURCE AccountOwnershipTransferStatusResponse @ squareup/onboard/activation/service.proto at 484:1
 */
export const AccountOwnershipTransferStatusResponse = $root.lookupType('squareup.onboard.activation.service.AccountOwnershipTransferStatusResponse');
fixType(AccountOwnershipTransferStatusResponse);
Builder.createAndAttachToType(AccountOwnershipTransferStatusResponse);
/**
 * SOURCE IneligibleForTransferReason @ squareup/onboard/activation/service.proto at 485:3
 */
AccountOwnershipTransferStatusResponse.IneligibleForTransferReason = $root.lookupEnum('squareup.onboard.activation.service.AccountOwnershipTransferStatusResponse.IneligibleForTransferReason').values;
/**
 * SOURCE GetTaxLocationsRequest @ squareup/onboard/activation/service.proto at 512:1
 */
export const GetTaxLocationsRequest = $root.lookupType('squareup.onboard.activation.service.GetTaxLocationsRequest');
fixType(GetTaxLocationsRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetTaxLocationsRequest);
/**
 * SOURCE GetTaxLocationsResponse @ squareup/onboard/activation/service.proto at 520:1
 */
export const GetTaxLocationsResponse = $root.lookupType('squareup.onboard.activation.service.GetTaxLocationsResponse');
fixType(GetTaxLocationsResponse);
Builder.createAndAttachToType(GetTaxLocationsResponse);
/**
 * SOURCE TaxLocation @ squareup/onboard/activation/service.proto at 521:3
 */
GetTaxLocationsResponse.TaxLocation = $root.lookupType('squareup.onboard.activation.service.GetTaxLocationsResponse.TaxLocation');
fixType(GetTaxLocationsResponse.TaxLocation);
Builder.createAndAttachToType(GetTaxLocationsResponse.TaxLocation);
/**
 * SOURCE GetBeneficialOwnersRequest @ squareup/onboard/activation/service.proto at 530:1
 */
export const GetBeneficialOwnersRequest = $root.lookupType('squareup.onboard.activation.service.GetBeneficialOwnersRequest');
fixType(GetBeneficialOwnersRequest);
Builder.createAndAttachToType(GetBeneficialOwnersRequest);
/**
 * SOURCE GetBeneficialOwnersResponse @ squareup/onboard/activation/service.proto at 533:1
 */
export const GetBeneficialOwnersResponse = $root.lookupType('squareup.onboard.activation.service.GetBeneficialOwnersResponse');
fixType(GetBeneficialOwnersResponse);
Builder.createAndAttachToType(GetBeneficialOwnersResponse);
/**
 * SOURCE PopulateStatus @ squareup/onboard/activation/service.proto at 536:3
 */
GetBeneficialOwnersResponse.PopulateStatus = $root.lookupEnum('squareup.onboard.activation.service.GetBeneficialOwnersResponse.PopulateStatus').values;
/**
 * SOURCE BeginDocIdvRequest @ squareup/onboard/activation/service.proto at 543:1
 */
export const BeginDocIdvRequest = $root.lookupType('squareup.onboard.activation.service.BeginDocIdvRequest');
fixType(BeginDocIdvRequest);
Builder.createAndAttachToType(BeginDocIdvRequest);
/**
 * SOURCE TestIdentity @ squareup/onboard/activation/service.proto at 548:3
 */
BeginDocIdvRequest.TestIdentity = $root.lookupType('squareup.onboard.activation.service.BeginDocIdvRequest.TestIdentity');
fixType(BeginDocIdvRequest.TestIdentity);
Builder.createAndAttachToType(BeginDocIdvRequest.TestIdentity);
/**
 * SOURCE DocumentType @ squareup/onboard/activation/service.proto at 557:3
 */
BeginDocIdvRequest.DocumentType = $root.lookupEnum('squareup.onboard.activation.service.BeginDocIdvRequest.DocumentType').values;
/**
 * SOURCE DocIdvSession @ squareup/onboard/activation/service.proto at 565:1
 */
export const DocIdvSession = $root.lookupType('squareup.onboard.activation.service.DocIdvSession');
fixType(DocIdvSession, {
  vendorName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(DocIdvSession);
/**
 * SOURCE BeginDocIdvResponse @ squareup/onboard/activation/service.proto at 578:1
 */
export const BeginDocIdvResponse = $root.lookupType('squareup.onboard.activation.service.BeginDocIdvResponse');
fixType(BeginDocIdvResponse);
Builder.createAndAttachToType(BeginDocIdvResponse);
/**
 * SOURCE BusinessCategoriesRequest @ squareup/onboard/activation/service.proto at 586:1
 */
export const BusinessCategoriesRequest = $root.lookupType('squareup.onboard.activation.service.BusinessCategoriesRequest');
fixType(BusinessCategoriesRequest);
Builder.createAndAttachToType(BusinessCategoriesRequest);
/**
 * SOURCE BusinessCategory @ squareup/onboard/activation/service.proto at 593:1
 */
export const BusinessCategory = $root.lookupType('squareup.onboard.activation.service.BusinessCategory');
fixType(BusinessCategory);
Builder.createAndAttachToType(BusinessCategory);
/**
 * SOURCE BusinessSubCategory @ squareup/onboard/activation/service.proto at 604:1
 */
export const BusinessSubCategory = $root.lookupType('squareup.onboard.activation.service.BusinessSubCategory');
fixType(BusinessSubCategory);
Builder.createAndAttachToType(BusinessSubCategory);
/**
 * SOURCE BusinessCategoriesResponse @ squareup/onboard/activation/service.proto at 611:1
 */
export const BusinessCategoriesResponse = $root.lookupType('squareup.onboard.activation.service.BusinessCategoriesResponse');
fixType(BusinessCategoriesResponse);
Builder.createAndAttachToType(BusinessCategoriesResponse);
/**
 * SOURCE TriggerUnitPaymentBrandEnrollmentRequest @ squareup/onboard/activation/service.proto at 616:1
 */
export const TriggerUnitPaymentBrandEnrollmentRequest = $root.lookupType('squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentRequest');
fixType(TriggerUnitPaymentBrandEnrollmentRequest);
Builder.createAndAttachToType(TriggerUnitPaymentBrandEnrollmentRequest);
/**
 * SOURCE TriggerUnitPaymentBrandEnrollmentResponse @ squareup/onboard/activation/service.proto at 624:1
 */
export const TriggerUnitPaymentBrandEnrollmentResponse = $root.lookupType('squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentResponse');
fixType(TriggerUnitPaymentBrandEnrollmentResponse);
Builder.createAndAttachToType(TriggerUnitPaymentBrandEnrollmentResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 625:3
 */
TriggerUnitPaymentBrandEnrollmentResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.TriggerUnitPaymentBrandEnrollmentResponse.Error').values;
/**
 * SOURCE GetUnitPaymentBrandEnrollmentStatusRequest @ squareup/onboard/activation/service.proto at 646:1
 */
export const GetUnitPaymentBrandEnrollmentStatusRequest = $root.lookupType('squareup.onboard.activation.service.GetUnitPaymentBrandEnrollmentStatusRequest');
fixType(GetUnitPaymentBrandEnrollmentStatusRequest);
Builder.createAndAttachToType(GetUnitPaymentBrandEnrollmentStatusRequest);
/**
 * SOURCE GetUnitPaymentBrandEnrollmentStatusResponse @ squareup/onboard/activation/service.proto at 656:1
 */
export const GetUnitPaymentBrandEnrollmentStatusResponse = $root.lookupType('squareup.onboard.activation.service.GetUnitPaymentBrandEnrollmentStatusResponse');
fixType(GetUnitPaymentBrandEnrollmentStatusResponse);
Builder.createAndAttachToType(GetUnitPaymentBrandEnrollmentStatusResponse);
/**
 * SOURCE RegisterEmoneyIntentRequest @ squareup/onboard/activation/service.proto at 661:1
 */
export const RegisterEmoneyIntentRequest = $root.lookupType('squareup.onboard.activation.service.RegisterEmoneyIntentRequest');
fixType(RegisterEmoneyIntentRequest);
Builder.createAndAttachToType(RegisterEmoneyIntentRequest);
/**
 * SOURCE RegisterEmoneyIntentResponse @ squareup/onboard/activation/service.proto at 666:1
 */
export const RegisterEmoneyIntentResponse = $root.lookupType('squareup.onboard.activation.service.RegisterEmoneyIntentResponse');
fixType(RegisterEmoneyIntentResponse);
Builder.createAndAttachToType(RegisterEmoneyIntentResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 667:3
 */
RegisterEmoneyIntentResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.RegisterEmoneyIntentResponse.Error').values;
/**
 * SOURCE GetUnifiedEmoneyEligibilityRequest @ squareup/onboard/activation/service.proto at 679:1
 */
export const GetUnifiedEmoneyEligibilityRequest = $root.lookupType('squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityRequest');
fixType(GetUnifiedEmoneyEligibilityRequest);
Builder.createAndAttachToType(GetUnifiedEmoneyEligibilityRequest);
/**
 * SOURCE GetUnifiedEmoneyEligibilityResponse @ squareup/onboard/activation/service.proto at 684:1
 */
export const GetUnifiedEmoneyEligibilityResponse = $root.lookupType('squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityResponse');
fixType(GetUnifiedEmoneyEligibilityResponse);
Builder.createAndAttachToType(GetUnifiedEmoneyEligibilityResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 685:3
 */
GetUnifiedEmoneyEligibilityResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.GetUnifiedEmoneyEligibilityResponse.Error').values;
/**
 * SOURCE UnitPaymentBrandEnrollmentStatus @ squareup/onboard/activation/service.proto at 699:1
 */
export const UnitPaymentBrandEnrollmentStatus = $root.lookupType('squareup.onboard.activation.service.UnitPaymentBrandEnrollmentStatus');
fixType(UnitPaymentBrandEnrollmentStatus);
Builder.createAndAttachToType(UnitPaymentBrandEnrollmentStatus);
/**
 * SOURCE GetJcbBankDataRequest @ squareup/onboard/activation/service.proto at 710:1
 */
export const GetJcbBankDataRequest = $root.lookupType('squareup.onboard.activation.service.GetJcbBankDataRequest');
fixType(GetJcbBankDataRequest);
Builder.createAndAttachToType(GetJcbBankDataRequest);
/**
 * SOURCE GetJcbBankDataResponse @ squareup/onboard/activation/service.proto at 715:1
 */
export const GetJcbBankDataResponse = $root.lookupType('squareup.onboard.activation.service.GetJcbBankDataResponse');
fixType(GetJcbBankDataResponse);
Builder.createAndAttachToType(GetJcbBankDataResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 716:3
 */
GetJcbBankDataResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.GetJcbBankDataResponse.Error').values;
/**
 * SOURCE SetJcbBankDataRequest @ squareup/onboard/activation/service.proto at 734:1
 */
export const SetJcbBankDataRequest = $root.lookupType('squareup.onboard.activation.service.SetJcbBankDataRequest');
fixType(SetJcbBankDataRequest);
Builder.createAndAttachToType(SetJcbBankDataRequest);
/**
 * SOURCE SetJcbBankDataResponse @ squareup/onboard/activation/service.proto at 742:1
 */
export const SetJcbBankDataResponse = $root.lookupType('squareup.onboard.activation.service.SetJcbBankDataResponse');
fixType(SetJcbBankDataResponse);
Builder.createAndAttachToType(SetJcbBankDataResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 743:3
 */
SetJcbBankDataResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.SetJcbBankDataResponse.Error').values;
/**
 * SOURCE CreateJcbSspRequestRequest @ squareup/onboard/activation/service.proto at 758:1
 */
export const CreateJcbSspRequestRequest = $root.lookupType('squareup.onboard.activation.service.CreateJcbSspRequestRequest');
fixType(CreateJcbSspRequestRequest, {
  target: {
    required: true
  }
});
Builder.createAndAttachToType(CreateJcbSspRequestRequest);
/**
 * SOURCE CreateJcbSspRequestResponse @ squareup/onboard/activation/service.proto at 762:1
 */
export const CreateJcbSspRequestResponse = $root.lookupType('squareup.onboard.activation.service.CreateJcbSspRequestResponse');
fixType(CreateJcbSspRequestResponse, {
  success: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(CreateJcbSspRequestResponse);
/**
 * SOURCE SspStatus @ squareup/onboard/activation/service.proto at 763:3
 */
CreateJcbSspRequestResponse.SspStatus = $root.lookupEnum('squareup.onboard.activation.service.CreateJcbSspRequestResponse.SspStatus').values;
/**
 * SOURCE CreateEmoneySspRequestRequest @ squareup/onboard/activation/service.proto at 777:1
 */
export const CreateEmoneySspRequestRequest = $root.lookupType('squareup.onboard.activation.service.CreateEmoneySspRequestRequest');
fixType(CreateEmoneySspRequestRequest, {
  target: {
    required: true
  }
});
Builder.createAndAttachToType(CreateEmoneySspRequestRequest);
/**
 * SOURCE CreateEmoneySspRequestResponse @ squareup/onboard/activation/service.proto at 781:1
 */
export const CreateEmoneySspRequestResponse = $root.lookupType('squareup.onboard.activation.service.CreateEmoneySspRequestResponse');
fixType(CreateEmoneySspRequestResponse, {
  success: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(CreateEmoneySspRequestResponse);
/**
 * SOURCE SspStatus @ squareup/onboard/activation/service.proto at 782:3
 */
CreateEmoneySspRequestResponse.SspStatus = $root.lookupEnum('squareup.onboard.activation.service.CreateEmoneySspRequestResponse.SspStatus').values;
/**
 * SOURCE ContinueJcbOnboardingRequest @ squareup/onboard/activation/service.proto at 796:1
 */
export const ContinueJcbOnboardingRequest = $root.lookupType('squareup.onboard.activation.service.ContinueJcbOnboardingRequest');
fixType(ContinueJcbOnboardingRequest);
Builder.createAndAttachToType(ContinueJcbOnboardingRequest);
/**
 * SOURCE ContinueJcbOnboardingResponse @ squareup/onboard/activation/service.proto at 801:1
 */
export const ContinueJcbOnboardingResponse = $root.lookupType('squareup.onboard.activation.service.ContinueJcbOnboardingResponse');
fixType(ContinueJcbOnboardingResponse);
Builder.createAndAttachToType(ContinueJcbOnboardingResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 802:3
 */
ContinueJcbOnboardingResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.ContinueJcbOnboardingResponse.Error').values;
/**
 * SOURCE JcbOnboardingStatus @ squareup/onboard/activation/service.proto at 810:3
 */
ContinueJcbOnboardingResponse.JcbOnboardingStatus = $root.lookupEnum('squareup.onboard.activation.service.ContinueJcbOnboardingResponse.JcbOnboardingStatus').values;
/**
 * SOURCE ShouldSkipBankLinkingStepRequest @ squareup/onboard/activation/service.proto at 829:1
 */
export const ShouldSkipBankLinkingStepRequest = $root.lookupType('squareup.onboard.activation.service.ShouldSkipBankLinkingStepRequest');
fixType(ShouldSkipBankLinkingStepRequest);
Builder.createAndAttachToType(ShouldSkipBankLinkingStepRequest);
/**
 * SOURCE ShouldSkipBankLinkingStepResponse @ squareup/onboard/activation/service.proto at 834:1
 */
export const ShouldSkipBankLinkingStepResponse = $root.lookupType('squareup.onboard.activation.service.ShouldSkipBankLinkingStepResponse');
fixType(ShouldSkipBankLinkingStepResponse);
Builder.createAndAttachToType(ShouldSkipBankLinkingStepResponse);
/**
 * SOURCE Error @ squareup/onboard/activation/service.proto at 835:3
 */
ShouldSkipBankLinkingStepResponse.Error = $root.lookupEnum('squareup.onboard.activation.service.ShouldSkipBankLinkingStepResponse.Error').values;
/**
 * SOURCE SetPrimaryIndividualControlRelationshipRequest @ squareup/onboard/activation/service.proto at 850:1
 */
export const SetPrimaryIndividualControlRelationshipRequest = $root.lookupType('squareup.onboard.activation.service.SetPrimaryIndividualControlRelationshipRequest');
fixType(SetPrimaryIndividualControlRelationshipRequest);
Builder.createAndAttachToType(SetPrimaryIndividualControlRelationshipRequest);
/**
 * SOURCE SetPrimaryIndividualControlRelationshipResponse @ squareup/onboard/activation/service.proto at 856:1
 */
export const SetPrimaryIndividualControlRelationshipResponse = $root.lookupType('squareup.onboard.activation.service.SetPrimaryIndividualControlRelationshipResponse');
fixType(SetPrimaryIndividualControlRelationshipResponse);
Builder.createAndAttachToType(SetPrimaryIndividualControlRelationshipResponse);
/**
 * SOURCE BusinessLookupRequest @ squareup/onboard/activation/service.proto at 862:1
 */
export const BusinessLookupRequest = $root.lookupType('squareup.onboard.activation.service.BusinessLookupRequest');
fixType(BusinessLookupRequest, {
  productIntent: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BusinessLookupRequest);
/**
 * SOURCE BusinessLookupResponse @ squareup/onboard/activation/service.proto at 868:1
 */
export const BusinessLookupResponse = $root.lookupType('squareup.onboard.activation.service.BusinessLookupResponse');
fixType(BusinessLookupResponse);
Builder.createAndAttachToType(BusinessLookupResponse);
/**
 * Request to go from IDV invitation "magic link" to info frontend needs to render async IDV flow
 *
 * SOURCE GetAsyncIDVInvitationInfoRequest @ squareup/onboard/activation/service.proto at 900:1
 */
export const GetAsyncIDVInvitationInfoRequest = $root.lookupType('squareup.onboard.activation.service.GetAsyncIDVInvitationInfoRequest');
fixType(GetAsyncIDVInvitationInfoRequest, {
  invitationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetAsyncIDVInvitationInfoRequest);
/**
 * Response to frontend with all of the data necessary for powering the async IDV flow
 *
 * SOURCE GetAsyncIDVInvitationInfoResponse @ squareup/onboard/activation/service.proto at 906:1
 */
export const GetAsyncIDVInvitationInfoResponse = $root.lookupType('squareup.onboard.activation.service.GetAsyncIDVInvitationInfoResponse');
fixType(GetAsyncIDVInvitationInfoResponse);
Builder.createAndAttachToType(GetAsyncIDVInvitationInfoResponse);
/**
 * SOURCE IdvInvitationStatus @ squareup/onboard/activation/service.proto at 907:3
 */
GetAsyncIDVInvitationInfoResponse.IdvInvitationStatus = $root.lookupEnum('squareup.onboard.activation.service.GetAsyncIDVInvitationInfoResponse.IdvInvitationStatus').values;
/**
 * SOURCE IndividualDocIdvRequest @ squareup/onboard/activation/service.proto at 935:1
 */
export const IndividualDocIdvRequest = $root.lookupType('squareup.onboard.activation.service.IndividualDocIdvRequest');
fixType(IndividualDocIdvRequest, {
  invitationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IndividualDocIdvRequest);
/**
 * SOURCE TestIdentity @ squareup/onboard/activation/service.proto at 940:3
 */
IndividualDocIdvRequest.TestIdentity = $root.lookupType('squareup.onboard.activation.service.IndividualDocIdvRequest.TestIdentity');
fixType(IndividualDocIdvRequest.TestIdentity);
Builder.createAndAttachToType(IndividualDocIdvRequest.TestIdentity);
/**
 * SOURCE DocumentType @ squareup/onboard/activation/service.proto at 949:3
 */
IndividualDocIdvRequest.DocumentType = $root.lookupEnum('squareup.onboard.activation.service.IndividualDocIdvRequest.DocumentType').values;
/**
 * SOURCE IndividualDocIdvResponse @ squareup/onboard/activation/service.proto at 957:1
 */
export const IndividualDocIdvResponse = $root.lookupType('squareup.onboard.activation.service.IndividualDocIdvResponse');
fixType(IndividualDocIdvResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(IndividualDocIdvResponse);
/**
 * SOURCE UpdateIndividualRequest @ squareup/onboard/activation/service.proto at 963:1
 */
export const UpdateIndividualRequest = $root.lookupType('squareup.onboard.activation.service.UpdateIndividualRequest');
fixType(UpdateIndividualRequest, {
  invitationToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateIndividualRequest);
/**
 * SOURCE GetIDVStatusForAllIndividualsInLegalEntityRequest @ squareup/onboard/activation/service.proto at 977:1
 */
export const GetIDVStatusForAllIndividualsInLegalEntityRequest = $root.lookupType('squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityRequest');
fixType(GetIDVStatusForAllIndividualsInLegalEntityRequest, {
  companyIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetIDVStatusForAllIndividualsInLegalEntityRequest);
/**
 * SOURCE CompanyIdentifier @ squareup/onboard/activation/service.proto at 978:3
 */
GetIDVStatusForAllIndividualsInLegalEntityRequest.CompanyIdentifier = $root.lookupType('squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityRequest.CompanyIdentifier');
fixType(GetIDVStatusForAllIndividualsInLegalEntityRequest.CompanyIdentifier);
Builder.createAndAttachToType(GetIDVStatusForAllIndividualsInLegalEntityRequest.CompanyIdentifier);
/**
 * SOURCE IndividualIdvStatusType @ squareup/onboard/activation/service.proto at 989:1
 */
export const IndividualIdvStatusType = $root.lookupEnum('squareup.onboard.activation.service.IndividualIdvStatusType').values;
/**
 * SOURCE GetIDVStatusForAllIndividualsInLegalEntityResponse @ squareup/onboard/activation/service.proto at 997:1
 */
export const GetIDVStatusForAllIndividualsInLegalEntityResponse = $root.lookupType('squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityResponse');
fixType(GetIDVStatusForAllIndividualsInLegalEntityResponse);
Builder.createAndAttachToType(GetIDVStatusForAllIndividualsInLegalEntityResponse);
/**
 * SOURCE IndividualInfo @ squareup/onboard/activation/service.proto at 998:3
 */
GetIDVStatusForAllIndividualsInLegalEntityResponse.IndividualInfo = $root.lookupType('squareup.onboard.activation.service.GetIDVStatusForAllIndividualsInLegalEntityResponse.IndividualInfo');
fixType(GetIDVStatusForAllIndividualsInLegalEntityResponse.IndividualInfo);
Builder.createAndAttachToType(GetIDVStatusForAllIndividualsInLegalEntityResponse.IndividualInfo);
/**
 * SOURCE SendIdvReminderEmailRequest @ squareup/onboard/activation/service.proto at 1020:1
 */
export const SendIdvReminderEmailRequest = $root.lookupType('squareup.onboard.activation.service.SendIdvReminderEmailRequest');
fixType(SendIdvReminderEmailRequest, {
  legalEntitiesStructureToken: {
    notEmpty: true
  },
  legalEntitiesNodeToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendIdvReminderEmailRequest);
/**
 * SOURCE SendIdvReminderEmailResponse @ squareup/onboard/activation/service.proto at 1025:1
 */
export const SendIdvReminderEmailResponse = $root.lookupType('squareup.onboard.activation.service.SendIdvReminderEmailResponse');
fixType(SendIdvReminderEmailResponse);
Builder.createAndAttachToType(SendIdvReminderEmailResponse);
/**
 * SOURCE SendIdvRetryEmailRequest @ squareup/onboard/activation/service.proto at 1029:1
 */
export const SendIdvRetryEmailRequest = $root.lookupType('squareup.onboard.activation.service.SendIdvRetryEmailRequest');
fixType(SendIdvRetryEmailRequest, {
  legalEntitiesStructureToken: {
    notEmpty: true
  },
  legalEntitiesNodeToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SendIdvRetryEmailRequest);
/**
 * SOURCE SendIdvRetryEmailResponse @ squareup/onboard/activation/service.proto at 1034:1
 */
export const SendIdvRetryEmailResponse = $root.lookupType('squareup.onboard.activation.service.SendIdvRetryEmailResponse');
fixType(SendIdvRetryEmailResponse);
Builder.createAndAttachToType(SendIdvRetryEmailResponse);
/**
 * SOURCE UpdateBeneficialOwnerDirectorEmailRequest @ squareup/onboard/activation/service.proto at 1038:1
 */
export const UpdateBeneficialOwnerDirectorEmailRequest = $root.lookupType('squareup.onboard.activation.service.UpdateBeneficialOwnerDirectorEmailRequest');
fixType(UpdateBeneficialOwnerDirectorEmailRequest, {
  legalEntitiesStructureToken: {
    notEmpty: true
  },
  legalEntitiesNodeToken: {
    notEmpty: true
  },
  email: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UpdateBeneficialOwnerDirectorEmailRequest);
/**
 * SOURCE UpdateBeneficialOwnerDirectorEmailResponse @ squareup/onboard/activation/service.proto at 1049:1
 */
export const UpdateBeneficialOwnerDirectorEmailResponse = $root.lookupType('squareup.onboard.activation.service.UpdateBeneficialOwnerDirectorEmailResponse');
fixType(UpdateBeneficialOwnerDirectorEmailResponse);
Builder.createAndAttachToType(UpdateBeneficialOwnerDirectorEmailResponse);
/**
 * SOURCE InitiateSellerNameChangeRequest @ squareup/onboard/activation/service.proto at 1054:1
 */
export const InitiateSellerNameChangeRequest = $root.lookupType('squareup.onboard.activation.service.InitiateSellerNameChangeRequest');
fixType(InitiateSellerNameChangeRequest);
Builder.createAndAttachToType(InitiateSellerNameChangeRequest);
/**
 * SOURCE GetBusinessVerificationStatusRequest @ squareup/onboard/activation/service.proto at 1057:1
 */
export const GetBusinessVerificationStatusRequest = $root.lookupType('squareup.onboard.activation.service.GetBusinessVerificationStatusRequest');
fixType(GetBusinessVerificationStatusRequest, {
  companyIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetBusinessVerificationStatusRequest);
/**
 * SOURCE BusinessVerificationStatus @ squareup/onboard/activation/service.proto at 1061:1
 */
export const BusinessVerificationStatus = $root.lookupType('squareup.onboard.activation.service.BusinessVerificationStatus');
fixType(BusinessVerificationStatus);
Builder.createAndAttachToType(BusinessVerificationStatus);
/**
 * SOURCE VerificationStatus @ squareup/onboard/activation/service.proto at 1062:3
 */
BusinessVerificationStatus.VerificationStatus = $root.lookupEnum('squareup.onboard.activation.service.BusinessVerificationStatus.VerificationStatus').values;
/**
 * SOURCE GetBusinessVerificationStatusResponse @ squareup/onboard/activation/service.proto at 1074:1
 */
export const GetBusinessVerificationStatusResponse = $root.lookupType('squareup.onboard.activation.service.GetBusinessVerificationStatusResponse');
fixType(GetBusinessVerificationStatusResponse);
Builder.createAndAttachToType(GetBusinessVerificationStatusResponse);
/**
 * SOURCE VerificationStatus @ squareup/onboard/activation/service.proto at 1075:3
 */
GetBusinessVerificationStatusResponse.VerificationStatus = $root.lookupEnum('squareup.onboard.activation.service.GetBusinessVerificationStatusResponse.VerificationStatus').values;
/**
 * SOURCE TriggerVerifyBusinessRequest @ squareup/onboard/activation/service.proto at 1089:1
 */
export const TriggerVerifyBusinessRequest = $root.lookupType('squareup.onboard.activation.service.TriggerVerifyBusinessRequest');
fixType(TriggerVerifyBusinessRequest, {
  companyIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TriggerVerifyBusinessRequest);
/**
 * SOURCE HandleC4BSignupRequest @ squareup/onboard/activation/service.proto at 1094:1
 */
export const HandleC4BSignupRequest = $root.lookupType('squareup.onboard.activation.service.HandleC4BSignupRequest');
fixType(HandleC4BSignupRequest);
Builder.createAndAttachToType(HandleC4BSignupRequest);
/**
 * SOURCE HandleC4BSignupResponse @ squareup/onboard/activation/service.proto at 1101:1
 */
export const HandleC4BSignupResponse = $root.lookupType('squareup.onboard.activation.service.HandleC4BSignupResponse');
fixType(HandleC4BSignupResponse);
Builder.createAndAttachToType(HandleC4BSignupResponse);
/**
 * SOURCE BeginTransferDocIdvRequest @ squareup/onboard/activation/service.proto at 1111:1
 */
export const BeginTransferDocIdvRequest = $root.lookupType('squareup.onboard.activation.service.BeginTransferDocIdvRequest');
fixType(BeginTransferDocIdvRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BeginTransferDocIdvRequest);
/**
 * SOURCE TransferDocIdvRemainingRetryCountRequest @ squareup/onboard/activation/service.proto at 1121:1
 */
export const TransferDocIdvRemainingRetryCountRequest = $root.lookupType('squareup.onboard.activation.service.TransferDocIdvRemainingRetryCountRequest');
fixType(TransferDocIdvRemainingRetryCountRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferDocIdvRemainingRetryCountRequest);
/**
 * SOURCE TransferDocIdvRemainingRetryCountResponse @ squareup/onboard/activation/service.proto at 1129:1
 */
export const TransferDocIdvRemainingRetryCountResponse = $root.lookupType('squareup.onboard.activation.service.TransferDocIdvRemainingRetryCountResponse');
fixType(TransferDocIdvRemainingRetryCountResponse);
Builder.createAndAttachToType(TransferDocIdvRemainingRetryCountResponse);
/**
 * SOURCE TransferMerchantTokenRequest @ squareup/onboard/activation/service.proto at 1134:1
 */
export const TransferMerchantTokenRequest = $root.lookupType('squareup.onboard.activation.service.TransferMerchantTokenRequest');
fixType(TransferMerchantTokenRequest, {
  uuid: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferMerchantTokenRequest);
/**
 * SOURCE TransferMerchantTokenResponse @ squareup/onboard/activation/service.proto at 1142:1
 */
export const TransferMerchantTokenResponse = $root.lookupType('squareup.onboard.activation.service.TransferMerchantTokenResponse');
fixType(TransferMerchantTokenResponse);
Builder.createAndAttachToType(TransferMerchantTokenResponse);
/**
 * Request to get the status of the primary individual's doc idv process
 * Will use the merchant token of the logged in user to find the primary individual
 *
 * SOURCE GetPrimaryIndividualDocIdvStatusRequest @ squareup/onboard/activation/service.proto at 1149:1
 */
export const GetPrimaryIndividualDocIdvStatusRequest = $root.lookupType('squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusRequest');
fixType(GetPrimaryIndividualDocIdvStatusRequest);
Builder.createAndAttachToType(GetPrimaryIndividualDocIdvStatusRequest);
/**
 * SOURCE GetPrimaryIndividualDocIdvStatusResponse @ squareup/onboard/activation/service.proto at 1152:1
 */
export const GetPrimaryIndividualDocIdvStatusResponse = $root.lookupType('squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusResponse');
fixType(GetPrimaryIndividualDocIdvStatusResponse);
Builder.createAndAttachToType(GetPrimaryIndividualDocIdvStatusResponse);
/**
 * SOURCE PrimaryIndividualDocIdvState @ squareup/onboard/activation/service.proto at 1156:3
 */
GetPrimaryIndividualDocIdvStatusResponse.PrimaryIndividualDocIdvState = $root.lookupEnum('squareup.onboard.activation.service.GetPrimaryIndividualDocIdvStatusResponse.PrimaryIndividualDocIdvState').values;
/**
 * SOURCE StartQuickVerifyRequest @ squareup/onboard/activation/service.proto at 1169:1
 */
export const StartQuickVerifyRequest = $root.lookupType('squareup.onboard.activation.service.StartQuickVerifyRequest');
fixType(StartQuickVerifyRequest, {
  phoneNumber: {
    required: true
  },
  ssnLast4: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(StartQuickVerifyRequest);
/**
 * SOURCE StartQuickVerifyResponse @ squareup/onboard/activation/service.proto at 1186:1
 */
export const StartQuickVerifyResponse = $root.lookupType('squareup.onboard.activation.service.StartQuickVerifyResponse');
fixType(StartQuickVerifyResponse);
Builder.createAndAttachToType(StartQuickVerifyResponse);
/**
 * SOURCE GetQuickVerifyStatusRequest @ squareup/onboard/activation/service.proto at 1193:1
 */
export const GetQuickVerifyStatusRequest = $root.lookupType('squareup.onboard.activation.service.GetQuickVerifyStatusRequest');
fixType(GetQuickVerifyStatusRequest, {
  verificationId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetQuickVerifyStatusRequest);
/**
 * Prefill data returned upon successful Quick Verify
 *
 * SOURCE QuickVerifyPrefillData @ squareup/onboard/activation/service.proto at 1199:1
 */
export const QuickVerifyPrefillData = $root.lookupType('squareup.onboard.activation.service.QuickVerifyPrefillData');
fixType(QuickVerifyPrefillData);
Builder.createAndAttachToType(QuickVerifyPrefillData);
/**
 * SOURCE GetQuickVerifyStatusResponse @ squareup/onboard/activation/service.proto at 1223:1
 */
export const GetQuickVerifyStatusResponse = $root.lookupType('squareup.onboard.activation.service.GetQuickVerifyStatusResponse');
fixType(GetQuickVerifyStatusResponse);
Builder.createAndAttachToType(GetQuickVerifyStatusResponse);
/**
 * SOURCE InProgress @ squareup/onboard/activation/service.proto at 1224:3
 */
GetQuickVerifyStatusResponse.InProgress = $root.lookupType('squareup.onboard.activation.service.GetQuickVerifyStatusResponse.InProgress');
fixType(GetQuickVerifyStatusResponse.InProgress);
Builder.createAndAttachToType(GetQuickVerifyStatusResponse.InProgress);
/**
 * SOURCE Complete @ squareup/onboard/activation/service.proto at 1225:3
 */
GetQuickVerifyStatusResponse.Complete = $root.lookupType('squareup.onboard.activation.service.GetQuickVerifyStatusResponse.Complete');
fixType(GetQuickVerifyStatusResponse.Complete);
Builder.createAndAttachToType(GetQuickVerifyStatusResponse.Complete);
/**
 * SOURCE Failure @ squareup/onboard/activation/service.proto at 1228:3
 */
GetQuickVerifyStatusResponse.Failure = $root.lookupType('squareup.onboard.activation.service.GetQuickVerifyStatusResponse.Failure');
fixType(GetQuickVerifyStatusResponse.Failure);
Builder.createAndAttachToType(GetQuickVerifyStatusResponse.Failure);
/**
 * SOURCE AcceptQuickVerifyPrefillRequest @ squareup/onboard/activation/service.proto at 1238:1
 */
export const AcceptQuickVerifyPrefillRequest = $root.lookupType('squareup.onboard.activation.service.AcceptQuickVerifyPrefillRequest');
fixType(AcceptQuickVerifyPrefillRequest, {
  verificationId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(AcceptQuickVerifyPrefillRequest);
/**
 * SOURCE Service @ squareup/onboard/activation/service.proto at 36:1
 */
export const Service = $root.lookupService('squareup.onboard.activation.service.Service');